import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Loader from '../../System/Components/Loader'
import dayjs from 'dayjs'
import AddressTable from './Components/AddressTable';
import { Button, Col, DatePicker, Form, Input, Modal, Row, Select } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { get, save } from '../../System/Api/API';
import { useGlobal } from '../../System/Global/GlobalProvider';
import { unescapeNested } from '../../System/Global/unescapeArray';
import { countryJson } from '../../System/Global/countryJson';

export const Addresses = () => {

        const { UserData } = useGlobal();
    const [ records, setRecords ] = useState([]);
    const [ showModal, setShowModal ] = useState(false)
    const [ dates, setDates ] = useState([dayjs().startOf('month'), dayjs().endOf('month')])
    const [selectedAddress, setSelectedAddress] = useState(null)
    
    useEffect(() => {

        loadRecords()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dates]) 

    const loadRecords = async () => {

        let _addresses = unescapeNested( await get('address_book', {clientKey: UserData.clientKey}, [{fieldName: 'name', orderDirection: 'asc'}]) )

        setRecords(_addresses)

        // setRecords( await fetchPurchases([dates[0].format('YYYY-MM-DD'), dates[1].format('YYYY-MM-DD')]) )
        
    }

    const addAddress = async (values) => {

        const adData = {
                clientKey: UserData.clientKey,
                userKey: UserData.userKey,
                ...values
        }

        if (selectedAddress?.abKey) {

                await save('address_book', adData, {abKey: selectedAddress.abKey})
        } else {
                await save('address_book', adData)
        }

        

        await loadRecords()

        setSelectedAddress(null)

        // let id = await savePurchase(values)
        setShowModal(false)
        // navigate(`/finance/purchases/orders/${id}`)

    }

    const columns = [
        {
            title: "Name",
            render: data => `${data.name}`,
            key: "name",
        },
        {
            title: "Address",
            render: data => {

                let ad1 = data.addressLine1 ? data.addressLine1 : "";
                let ad2 = data.addressLine2 ? data.addressLine2 : "";
                let ad3 = data.addressLine3 ? data.addressLine3 : "";
                let town = data.townName ? data.townName : "";
                let postCode = data.postCode ? data.postCode : "";
                let country = data.country ? data.country : "";

                return (
                        ad1 + " " + ad2 + " " + ad3 + " " + town + " " + postCode + " " + country
                )
                
            },
            key: "address",
        },
        {
            title: "Telephone",
            render: data => {
                let telephone = data.telephone || "";
                if (telephone && telephone[0] !== '0') {
                    telephone = '0' + telephone;
                }
                return telephone;
            },
            key: "telephone",
        },
        
    ]

    const selectAddress = (record) => {

        setSelectedAddress(record)

        setShowModal(true)

    }

    return (
        records ?
        <div style={{padding: 20}}>
            <div style={{display: 'flex', alignItems: "center"}}>
                <div style={{flex: 1}}>
                    <h2 style={{marginTop: 0, paddingLeft: 20}}>Address Book</h2>
                </div>
                <div style={{marginRight: 20}}>
                    {/* <DatePicker.RangePicker value={dates} format={"DD/MM/YYYY"} onChange={(dates) => setDates(dates)} ranges={presetRanges}/> */}
                </div>
                <div>
                    <Button style={{height: 43}} onClick={() => { setSelectedAddress(null); setShowModal(true) } } setShowModal type="primary">Create address</Button>
                </div>
            </div>

            <AddressModal showModal={showModal} setShowModal={setShowModal} saveAddress={addAddress} selectedAddress={selectedAddress} />
            <div style={{height: 'calc(100vh - 100px)', overflowY: 'scroll'}}>
            <AddressTable 
                columns={columns}
                records={records} 
                row_key="abKey"
                selectRow={selectAddress}
            /> 
            </div>
            
        </div>
        : <Loader />
        
    )
    
}

export default Addresses;

const AddressModal = ({ showModal, setShowModal, saveAddress, selectedAddress }) => {
    
    const [modalForm] = useForm();
    

    useEffect( () => {

        ( async () => { 

                if (selectedAddress) {
                        console.log('Address selected', selectedAddress)

                        modalForm.setFieldsValue(selectedAddress)
                } else {
                        console.log('No address selected')
                        modalForm.resetFields()
                }
        //     setSuppliers(await fetchFinanceRecords({component: "Supplier"})) 
        //     setContracts(await fetchContractsBasic()) 
         })()

    }, [selectedAddress])

    
    
    return (
        <Modal open={showModal} onCancel={() => setShowModal(false)} footer={
            <>
                <Button onClick={() => modalForm.submit()} type="primary">Save address</Button>
            </>
            }
        >
            <h2 className="modalTitle">Address details</h2>
            <div className="modalContent">

                
                <div className="section2">
                <div style={{ padding: '20px 30px' }}>
                    <Form layout="vertical" onFinish={saveAddress} form={modalForm} initialValues={{country: "United Kingdom"}}>
                        <Form.Item label="Name" name="name"  rules={[{ required: true, message: 'Please enter a name' }]}>
                                <Input type="text" />
                        </Form.Item>
                        <Form.Item label="Address" name="addressLine1"  rules={[{ required: true, message: 'Please enter line 1' }]}>
                                <Input type="text" />
                        </Form.Item>
                        <Form.Item name="addressLine2">
                                <Input type="text" />
                        </Form.Item>
                        <Form.Item name="addressLine3">
                                <Input type="text" />
                        </Form.Item>
                        <Form.Item label="Town" name="townName" rules={[{ required: true, message: 'Please enter a town' }]}>
                                <Input type="text" />
                        </Form.Item>
                        <Form.Item label="Post Code" name="postCode" rules={[{ required: true, message: 'Please enter a post code' }]}>
                                <Input type="text" />
                        </Form.Item>
                        <Form.Item label="Country" name="country" rules={[{ required: true, message: 'Please choose a country!' }]}>
                                <Select
                                        showSearch
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                        option.children.toLowerCase().includes(input.toLowerCase())
                                        }
                                >
                                        <Select.Option value={"United Kingdom"}>United Kingdom</Select.Option>
                                        { countryJson.map( (country, index) => <Select.Option key={index} value={country.name}>{country.name}</Select.Option> ) }
                                        
                                </Select>
                        </Form.Item>
                        <Form.Item style={{marginTop: 20}} label="Telephone" name="telephone" rules={[{ required: true, message: 'Please enter a telephone' }]}>
                                <Input type="text" />
                        </Form.Item>
                        
                    </Form>
                    </div>
                </div>
            </div>
        </Modal>
    );
};